import React, { useState, useEffect } from 'react';
import style from './FullScreen.module.css';
import defaultLogo from '../../assets/images/logo2.png';

export function FullScreen({ logo }: { logo: string }) {
  return (
    <div className={style.container}>
      <div className={style.main}>
        <div className={style.entry}>
          <img src={logo || defaultLogo} className={style.logo} />
          <div className={style.slogen}>让数据价值看得见</div>
        </div>
        <div className={style.earth}></div>
      </div>
    </div>
  );
}
